/* =========================================================
   ByUR Scroll Reveal System
   ========================================================= */

(function () {
  'use strict';

  document.documentElement.classList.add('js');

  const selector = [
    '.byur-reveal',
    '.byur-reveal-scale',
    '.byur-reveal-left',
    '.byur-reveal-right'
  ].join(',');

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  let observer = null;


  /* -------------------------------------------------------
     Immediately reveal an element
     ------------------------------------------------------- */

  function showElement(element) {
    element.classList.add('is-visible');
  }


  /* -------------------------------------------------------
     Create IntersectionObserver once
     ------------------------------------------------------- */

  function getObserver() {
    if (observer) {
      return observer;
    }

    observer = new IntersectionObserver(
      function (entries, currentObserver) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          showElement(entry.target);

          /*
            Animation happens only once.
          */
          currentObserver.unobserve(entry.target);
        });
      },
      {
        /*
          Start the animation when roughly 12% of
          the element has entered the viewport.
        */
        threshold: 0.12,

        /*
          Trigger slightly before it moves deeply
          into the visible area.
        */
        rootMargin: '0px 0px -4% 0px'
      }
    );

    return observer;
  }


  /* -------------------------------------------------------
     Initialize animation elements inside a given container
     ------------------------------------------------------- */

  function initRevealAnimations(root) {
    root = root || document;

    const elements = root.querySelectorAll(selector);

    if (!elements.length) return;


    /*
      Accessibility:
      reveal everything immediately if reduced motion
      is enabled.
    */

    if (prefersReducedMotion.matches) {
      elements.forEach(function (element) {
        showElement(element);
      });

      return;
    }


    const currentObserver = getObserver();

    elements.forEach(function (element) {
      /*
        Avoid registering the same element multiple times.
      */

      if (element.dataset.byurRevealInitialized === 'true') {
        return;
      }

      element.dataset.byurRevealInitialized = 'true';

      currentObserver.observe(element);
    });
  }


  /* -------------------------------------------------------
     Normal storefront initialization
     ------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRevealAnimations(document);
    });
  } else {
    initRevealAnimations(document);
  }


  /* -------------------------------------------------------
     Shopify Theme Editor Support

     Shopify can dynamically destroy/recreate sections
     while you're customizing the theme.
     ------------------------------------------------------- */

  document.addEventListener('shopify:section:load', function (event) {
    initRevealAnimations(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initRevealAnimations(event.target);
  });


  /* -------------------------------------------------------
     If user changes reduced-motion preference while
     the page is open, reveal everything.
     ------------------------------------------------------- */

  prefersReducedMotion.addEventListener('change', function (event) {
    if (!event.matches) return;

    document.querySelectorAll(selector).forEach(function (element) {
      showElement(element);

      if (observer) {
        observer.unobserve(element);
      }
    });
  });
})();